import { render, staticRenderFns } from "./AddBalance.vue?vue&type=template&id=071b6fae&scoped=true&"
import script from "./AddBalance.vue?vue&type=script&lang=ts&"
export * from "./AddBalance.vue?vue&type=script&lang=ts&"
import style0 from "./AddBalance.vue?vue&type=style&index=0&id=071b6fae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b6fae",
  null
  
)

export default component.exports